import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { convertReq, convertName } from '../utils/util';
import { updateProgramReq, setProgramReq } from '../../../../store/modules/zenomSlice';

import { InputText } from 'primereact/inputtext';

export default function ProgramReq({ req = null, title = null }) {
    const { selectedProgram } = useSelector((state) => state.modules);
    const { programReq } = useSelector((state) => state.zenom);
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedProgram && !req) {
            dispatch(setProgramReq(convertReq(selectedProgram?.requirements.split(','))));
        }

        if (req) {
            dispatch(setProgramReq(req));
        }
    }, []);

    const onProgramInputChange = (e, title) => {
        dispatch(updateProgramReq({ title, value: e.target.value }));
    };

    return (
        <div className="w-full">
            <form className="mt-5">
                <h3>{selectedProgram?.title || title}</h3>
                {programReq &&
                    Object.keys(programReq)?.map((req, i) => {
                        return (
                            <div key={i} className="py-3">
                                <div className="w-full mb-2">
                                    <label htmlFor={req}>{convertName(req)}</label>
                                </div>
                                <div className="w-full">
                                    <InputText onChange={(e) => onProgramInputChange(e, req)} placeholder={convertName(req)} value={programReq[req]} type="text" className="w-full" />
                                </div>
                            </div>
                        );
                    })}
            </form>
        </div>
    );
}
